module.exports = __webpack_public_path__ + "static/evergreen-pane-elevation-5a8def277ba7c8c5b7d1143364d572b6.png";